import styled from '@emotion/styled';
import { Checkbox } from '@mui/material';

import { getColor } from '../common/UICommon';

export const InputRoot = styled.div`
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  color: ${getColor('BLACK_80')};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  .PhoneInput {
    font-family: 'Poppins';
    padding: 14px 16px;
    border-radius: 4px;
    background-color: ${getColor('WHITE')};
    .PhoneInputInput {
      outline: none;
      height: 24px;
      font-size: 16px;
      border: none;
      background-color: ${getColor('WHITE')};
      &::placeholder {
        color: ${getColor('BLACK_60')};
        font-size: 16px;
      }
    }
    .PhoneInputCountry {
      margin-right: 8px;
    }
    .PhoneInputCountrySelectArrow {
      color: ${getColor('BLACK')};
      opacity: 1;
    }

    &.error {
      border: 1px solid ${getColor('RED_100')};

      .PhoneInputInput {
        color: ${getColor('RED_100')};
      }
    }
  }
`;

export const Label = styled.p`
  margin-bottom: 8px;
  font-weight: 600;
  font-size: 14px;
  color: ${getColor('BLACK')};
`;

export const TermsLabel = styled.p`
  padding-top: 12px;
  font-weight: 400;
  font-size: 12px;
  color: ${getColor('GRAY_60')};
`;

export const ErrorInputText = styled.p`
  color: ${getColor('RED_100')};
  margin-top: 8px;
  font-weight: 600;
`;

export const PopUpText = styled.p`
  margin: 24px 0;
  text-align: center;
`;

export const CheckboxMUI = styled(Checkbox)`
  &.MuiCheckbox-root {
    padding: 0;
    padding-right: 12px;
  }
`;

export const Terms = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${getColor('BLACK_80')};
`;

export const SpanLink = styled.span`
  font-weight: 600;
  cursor: pointer;
  color: ${getColor('PURPLE_60')};
  text-decoration: none;
  :focus-visible {
    outline: none;
  }
`;
